import axios from "axios";
import { Base_URL } from "../url";

export const fetchResources = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/ResourceMasters/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching resources!";
  }
};

export const downloadResourceMasterExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/SalaryProcess/DownloadResourceMasterExcel`,
      {}, // empty body since it's a POST request
      {
        responseType: 'blob' // important for file downloads
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading resource data!";
  }
};